<template>
    <div class='background'>
        <navbar :transparent="false" position="relative" :show-navbar="showMenu">
            <a class="navbar-brand" to="/">{{ title }}</a>
            <div class="navbar-toggle" :class="{toggled: showMenu}">
              <navbar-toggle-button @click.native="toggleNavbar">
              </navbar-toggle-button>
            </div>
            <template slot="navbar-menu" v-if="header.signup || header.subscriptions">
                <router-link v-if="header.signup" class="nav-item" tag="li" to="/register">
                    <a class="nav-link">
                        <i class="now-ui-icons tech_mobile"></i>
                        {{ $t('Registration') }}
                    </a>
                </router-link>

                <router-link class="nav-item" tag="li" to="/auth">
                    <a class="nav-link">
                        <i class="now-ui-icons users_circle-08"></i>
                        {{ $t('Enter') }}
                    </a>
                </router-link>

                <router-link v-if="header.subscriptions" class="nav-item" tag="li" :to="{ name: 'GuestConstructor' }">
                    <a class="nav-link">
                        <i class="now-ui-icons business_money-coins"></i>
                        {{$t('Products')}}
                    </a>
                </router-link>
                <language-dropdown :hasBlackBorder="true"/>
            </template>
        </navbar>
        <zoom-center-transition :duration="pageTransitionDuration" mode="out-in" class="form-wrapper">
          <div class="form-wrapper">
              <router-view></router-view>
          </div>
        </zoom-center-transition>
    </div>
</template>

<script>
/* eslint-disable no-new */
import { Navbar, NavbarToggleButton } from '@/ui'
import { ZoomCenterTransition } from 'vue2-transitions'
import { mapState } from 'vuex'
import LanguageDropdown from './components/LanguageDropdown'

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    ZoomCenterTransition,
    LanguageDropdown
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data () {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page'
    }
  },
  computed: {
    imageStyles () {
      let img = require('@/assets/img/bg13.jpg')
      return {
        backgroundImage: `url(${img})`
      }
    },
    ...mapState({
      title: state => state.config.data.title,
      header: state => state.config.data.header
    })
  },
  methods: {
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
      this.showMenu = !this.showMenu
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },
    setPageClass () {
      this.pageClass = `${this.$route.name}-page`.toLowerCase()
    }
  },
  beforeDestroy () {
    this.closeMenu()
  },
  beforeRouteUpdate (to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu()
      setTimeout(() => {
        next()
      }, this.menuTransitionDuration)
    } else {
      next()
    }
  },
  watch: {
    $route () {
      this.setPageClass()
    }
  }
}
</script>
<style lang="scss" scoped>
  .background {
    min-height: 100%;
    background-color: #F5FAFF;
  }
  .form-wrapper {
    margin-top: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  $scaleSize: .8;
  @keyframes zoomIn8 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    100% {
      opacity: 1;
    }
  }
  .wrapper-full-page .zoomIn {
    animation-name: zoomIn8;
  }
  @keyframes zoomOut8 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .wrapper-full-page .zoomOut {
    animation-name: zoomOut8;
  }
</style>
